import React from "react";
import { Checkbox, FormControl, FormControlLabel } from "@mui/material";

import { Controller } from "react-hook-form";
import { fontSize, fontWeight } from "@mui/system";
const ISBARCheckbox = ({
  value,
  onChange,
  name,
  label,
  control,
  defaultValue,
  style,
  checkBoxStyle,
  disabled,
}) => {
  return (
    <>
      <FormControl>
        <Controller
          name={name}
          control={control}
          defaultValue={defaultValue || false}
          render={({ field }) => (
            <FormControlLabel
              label={<span className="text-[12px] xl:text-[14px]">{label}</span>}
              control={
                <Checkbox
                  checked={field.value || false}
                  disabled={disabled}
                  style={style}
                  onChange={(e) => {
                    field.onChange(e.target.checked);

                    if (onChange) {
                      onChange(e.target.checked);
                    }
                  }}
                />
              }
            />
          )}
        />
      </FormControl>
    </>
  );
};

export default ISBARCheckbox;